import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import EpiContext from '@episerver/spa-core/Spa';

const redirectButton = (props) => {
  return (
    <div className='redirect-button' onClick={() => props.onClick()}>
      <p className='text'>{props.titleText}</p>
      <div className='circle'>
        <Image src={require('../images/arrow-white.svg')} alt='חץ' />
      </div>
    </div>
  );
};

export default redirectButton;
